$(function () {
    let dataTable;
    let currentBuyerId;
    const searchPhoneBuyerModal = new bootstrap.Modal('#search_phone_name_selector');
    const searchPhoneBuyerModalBody = $('#search_phone_name_selector_body');
    const buyerName = $('#buyer_name');
    const phone = $('#phone');
    const options = {
        stateSave: true,
        processing: true,
        serverSide: true,
        order: [
            [4, 'desc']
        ],
        columns: [
            {
                data: 'buyer',
            },
            {
                data: 'status',
                render: function (data, type, row) {
                    if (type === 'display') {
                        return row.status_string;
                    }

                    return data;
                }
            },
            {
                data: 'total',
            },
            {
                data: 'created_at',
            },
            {
                data: 'updated_at',
            },
            {
                data: 'id',
                render: function (data, type) {
                    if (type === 'display') {
                        let html = '';
                        const detailUrl = apiOrderDetailPath.replace('order_id', data);

                        html += `<a href="${detailUrl}" target="_blank" class="btn btn-sm btn-primary">細節</a>`

                        return html;
                    }

                    return data;
                }
            }
        ]
    };

    function drawTable(data = []) {
        const finalOption = $.extend(options, {
            ajax: {
                url: apiPath,
                data: {
                    buyer_id: currentBuyerId
                }
            }
        });
        dataTable = chanDrawTable
            .setColumn(finalOption)
            .setSearchModule([['#search_phone', 1, 'input'], ['#search_status', 2, 'change']])
            .draw('#data_table', data);
    }

    buyerName.autocomplete({
        source: apiClientPath,
        delay: 500,
        select: (event, ui) => {
            currentBuyerId = ui.item.id;
            phone.val('');
            drawTable();
        }
    });

    $('#btn_search_phone').on('click', function () {
        if (phone.val().trim() === '') {
            return;
        }

        chanMessage.loader.open();

        $.getJSON(apiBuyerSearchPhoneUrl, {
            phone: phone.val()
        }).done(function (response) {
            if (response.length === 0) {
                chanMessage.alert('沒有符合的號碼');
            } else if (response.length === 1) {
                buyerName.val(response[0].name);
                currentBuyerId = response[0].id
                drawTable();
            } else {
                searchPhoneBuyerModalBody.html($('#search_phone_buyer_selector_template').render(response));
                searchPhoneBuyerModal.show();
            }
        }).fail(function () {
            chanMessage.alert('發生錯誤');
        }).always(function () {
            chanMessage.loader.close();
        });
    });

    searchPhoneBuyerModalBody.on('click', 'a', function() {
        const name = $(this).data('name');
        const id = $(this).data('id');

        buyerName.val(name);
        currentBuyerId = id;
        drawTable();

        searchPhoneBuyerModal.hide();
        return false;
    });
});
